// Consolidate held transactions into one row per stock (by ticker + instrument type).
export const consolidateHoldings = (transactions) => {
  const held = (transactions || []).filter((t) => t.status === 'held');
  const map = {};
  held.forEach((t) => {
    const key = `${(t.ticker || '').trim().toUpperCase()}|${t.instrumentType || 'Equity'}`;
    if (!map[key]) {
      map[key] = {
        ticker: t.ticker,
        shareName: t.shareName,
        instrumentType: t.instrumentType || 'Equity',
        exchange: t.exchange,
        quantity: 0,
        totalCost: 0,
        currentValue: 0,
        profit: 0,
        dayChange: 0,
        currentMarketPrice: t.currentMarketPrice,
        previousClose: t.previousClose || null,
        lots: 0,
      };
    }
    const h = map[key];
    h.quantity += t.quantity || 0;
    h.totalCost += t.totalCost || 0;
    h.currentValue += t.currentValue || 0;
    h.profit += t.profit || 0;
    h.dayChange += t.dayChange || 0;
    h.currentMarketPrice = t.currentMarketPrice;
    if (t.previousClose) h.previousClose = t.previousClose;
    h.lots += 1;
  });
  return Object.values(map).map((h) => {
    const prevValue = h.currentValue - h.dayChange;
    return {
      ...h,
      hasPrevClose: !!h.previousClose,
      avgPrice: h.quantity > 0 ? h.totalCost / h.quantity : 0,
      returnPercentage: h.totalCost > 0 ? (h.profit / h.totalCost) * 100 : 0,
      dayChangePercent: prevValue > 0 ? (h.dayChange / prevValue) * 100 : 0,
    };
  });
};

const slice25 = (arr) => arr.slice(0, 25);

// Build the four ranked Top-25 lists for the Daily Summary, all consolidated stock-wise.
export const buildTopLists = (transactions) => {
  const holdings = consolidateHoldings(transactions);
  const byValue = [...holdings].sort((a, b) => b.currentValue - a.currentValue);
  const byReturnPct = [...holdings].sort((a, b) => b.returnPercentage - a.returnPercentage);
  const byProfit = [...holdings].sort((a, b) => b.profit - a.profit);
  // Daily movers: ranked by today's gain/loss in ₹ value (dayChange), held positions with a prev close.
  const byDay = [...holdings].filter((h) => h.hasPrevClose).sort((a, b) => (b.dayChange || 0) - (a.dayChange || 0));
  return {
    holdings,
    topByValue: slice25(byValue),
    topGainersPct: slice25(byReturnPct.filter((h) => h.profit > 0)),
    topLosersPct: slice25([...byReturnPct].reverse().filter((h) => h.profit < 0)),
    topGainersValue: slice25(byProfit.filter((h) => h.profit > 0)),
    topLosersValue: slice25([...byProfit].reverse().filter((h) => h.profit < 0)),
    topGainersDay: slice25(byDay.filter((h) => (h.dayChange || 0) > 0)),
    topLosersDay: slice25([...byDay].reverse().filter((h) => (h.dayChange || 0) < 0)),
  };
};

export const fmtINR = (n) =>
  (n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
